import { isRequired } from "./BriefUtils";
import React, { useState, useEffect } from "react";
import BriefDropdownList from "../../components/BriefDropDownList/BriefDropdownList";
import BriefDateDropdown from "../../components/BriefDropDownList/BriefDateDropdown";
import { Globals as OldGlobals } from "../../global/Globals";
import TextArea from "../../components/TextArea/TextArea";
import "react-datepicker/dist/react-datepicker.css";
import CryptoUtils from "../../util/cryptoUtils";
import { useSelector, useDispatch } from "react-redux";
import { setIsBriefDetailsAtLeastPartiallyFilled } from "./CreateBriefSlice";
import { useLanguage } from '../../context/Languagecontext';
import { formatclusterandroleName } from "../../util/util";

export const BriefDetailsUI = ({
  handleTitleSelection,
  handleTextArea,
  handleDate,
  handleInfo,
  handleBriefDetailsData,
  handleOnCloseDateChange,
  propsData,
}) => {
   const { Globals } = useLanguage();
  const [formData, setFormData] = useState({
    CHANNEL: propsData?.channelId ? [propsData?.channelId] : "",
    LANGUAGE: propsData?.languageId ? [propsData?.languageId] : "",
    GENRE: propsData?.genreId ? [propsData?.genreId] : "",
    FORMAT: propsData?.formatId ? [propsData?.formatId] : "",
    PRODUCTION_TYPE: propsData?.productionTypeId
      ? [propsData?.productionTypeId]
      : "",
    DESCRIPTION: propsData?.description || "",
    SUBMISSION_REQUIREMENT: propsData?.submissionRequirements || "",
    CLOSING_DATE: (propsData?.closingDate!==Globals.DEFAULT_MIN_DATE && propsData?.closingDate!==undefined && propsData?.closingDate!==null)
      ? new Date(propsData?.closingDate)
      : "",
  });
  const [clusterInfo, setClusterInfo] = useState(null);
  const [inValidateMandatoryField, setInValidateMandatoryField]=useState({
  isChannelInValid:false,
  isLanguageInValid:false,
  isGenreInValid:false,
  isFormatInValid:false,
  isProductionTypeInValid:false,
  isDescriptionInValid:false,
  isSubmissionRequirementInValid:false,
  isClosingDateInValid:false,
  isCESelectionInValid:false,
  isCEEvalDeadlineInValid:false,
  isSMEvalDeadlineInValid:false,
  isEvalCriteriaInValid:false,
  isClodeBriefProducersInValid:false,
});
  const dispatch = useDispatch();
  const isCEDeadlineClicked = useSelector(state => state.createBrief.isCEDeadlineClicked);
  const isBriefDetailsValid = useSelector(state => state.createBrief.isBriefDetailsValid);
  const isSaveAsDraftClicked = useSelector(state => state.createBrief.isSaveAsDraftClicked);
  useEffect(() => {
    const newCluster=Globals.CLUSTERNAME[formatclusterandroleName(JSON.parse(CryptoUtils.getFromLocalStorage("clusterName"))?.[0]?.clusterName)];
    if (newCluster) {
      setClusterInfo({clusterName:newCluster});
    }
  }, []);

  useEffect(() => {
    handleBriefDetailsData(formData);
  }, [formData]);

  const handleSelect = (dropdownName, selectedValues) => {
    setFormData((prevData) => {
      const updated = { ...prevData, [dropdownName]: selectedValues };
      if (dropdownName === "CHANNEL") updated.LANGUAGE = "";
      return updated;
    });
    resetErrorOnChange(dropdownName);
  };

  const onDateChange = (name, value) => {
    if(name === "CLOSING_DATE") {
      handleOnCloseDateChange()
    }
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    validateClosingDate();
    resetErrorOnChange(name);
  };

  const handleTextAreaChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
    resetErrorOnChange(name);
  };

  const handleDateChange = (name, value) => {
    setFormData((prevData) => ({
      ...prevData,
      [name]: value,
    }));
  };

  const validateChannel = () => {
    setInValidateMandatoryField((prevState) => ({
      ...prevState,
      isChannelInValid: (!formData.CHANNEL && formData.CHANNEL.length === 0) ? true : false
    }))
  }

  const validateLanguage = () => {
    if(!formData.CHANNEL || formData.CHANNEL.length === 0) {
      validateChannel();
    }
    else{
    setInValidateMandatoryField((prevState) => ({
      ...prevState,
      isLanguageInValid: (!formData.LANGUAGE && formData.LANGUAGE.length === 0) ? true : false
    }))
  }
  }

  const validateGenre = () => {
    setInValidateMandatoryField((prevState) => ({
      ...prevState,
      isGenreInValid: (!formData.GENRE && formData.GENRE.length === 0) ? true : false
    }))
  }

  const validateFormat = () => {
    setInValidateMandatoryField((prevState) => ({
      ...prevState,
      isFormatInValid: (!formData.FORMAT && formData.FORMAT.length === 0) ? true : false
    }))
  }

  const validateProductionType = () => {
    setInValidateMandatoryField((prevState) => ({
      ...prevState,
      isProductionTypeInValid: (!formData.PRODUCTION_TYPE && formData.PRODUCTION_TYPE.length === 0) ? true : false
    }))
  }

  const validateDescription = () => {
    setInValidateMandatoryField((prevState) => ({
      ...prevState,
      isDescriptionInValid: (!formData.DESCRIPTION && formData.DESCRIPTION.length === 0) ? true : false
    }))
  }

  const validateSubmissionRequirement = () => {
    setInValidateMandatoryField((prevState) => ({
      ...prevState,
      isSubmissionRequirementInValid: (!formData.SUBMISSION_REQUIREMENT && formData.SUBMISSION_REQUIREMENT.length === 0) ? true : false
    }))
  }

  const validateClosingDate = () => {
    setInValidateMandatoryField((prevState) => ({
      ...prevState,
      isClosingDateInValid: (formData.CLOSING_DATE==="") ? true : false
    }))
  }

  useEffect(() => {
    if (isCEDeadlineClicked) {
      validateClosingDate();
    }
  }, [isCEDeadlineClicked])

  // useEffect(()=>{
  //   if(isBriefDetailsValid===false && isSaveAsDraftClicked===true){
  //     validateChannel();
  //     validateDescription();
  //     validateClosingDate();
  //     validateFormat();
  //     validateGenre();
  //     validateLanguage();
  //     validateProductionType();
  //     validateSubmissionRequirement();
  //   }
  // },[isBriefDetailsValid, isSaveAsDraftClicked])

  useEffect(() => {
    const doesFormHaveValu = (formData.CHANNEL.length > 0 || formData.CLOSING_DATE !== "" ||
      formData.DESCRIPTION.length > 0 || formData.FORMAT.length > 0 || formData.GENRE.length > 0 ||
      formData.LANGUAGE.length > 0 || formData.PRODUCTION_TYPE.length > 0 || formData.SUBMISSION_REQUIREMENT.length > 0);
    dispatch(setIsBriefDetailsAtLeastPartiallyFilled({ isBriefDetailsPartiallyFilled: doesFormHaveValu }))
  })

  const resetErrorOnChange=(fieldName)=>{
    console.log("fieldName ===> ", fieldName);
    switch (fieldName){
      case 'CHANNEL': setInValidateMandatoryField((prevState)=>({...prevState, isChannelInValid:false})); break;
      case 'LANGUAGE': setInValidateMandatoryField((prevState)=>({...prevState, isLanguageInValid:false})); break;
      case 'GENRE': setInValidateMandatoryField((prevState)=>({...prevState, isGenreInValid:false})); break;
      case 'FORMAT': setInValidateMandatoryField((prevState)=>({...prevState, isFormatInValid:false})); break;
      case 'PRODUCTION_TYPE': setInValidateMandatoryField((prevState)=>({...prevState, isDescriptionInValid:false})); break;
      case 'SUBMISSION_REQUIREMENT': setInValidateMandatoryField((prevState)=>({...prevState, isSubmissionRequirementInValid:false})); break;
      case 'CLOSING_DATE': setInValidateMandatoryField((prevState)=>({...prevState, isClosingDateInValid:false})); break;
    }
  }
  return (
    <div className="brief-container">
      <div className="brief-heading-section">
        <label className="brief-basic-details-text">
          {Globals.CREATE_NEW_BRIEF.BASIC_DETAILS}
        </label>
        <label className="brief-label-title">
          {Globals.CREATE_NEW_BRIEF.BASIC_DETAILS_SUBTITLE}{" "}
          <span>
            {clusterInfo ? clusterInfo?.clusterName : ""}
          </span>
        </label>
      </div>

      <div className="brief-form-row">
        <div className="brief-form-group">
          {isRequired(Globals.CREATE_NEW_BRIEF.CHANNEL)}
          <span onBlur={validateChannel} tabIndex={1}><BriefDropdownList
            multiSelection={false}
            name="CHANNEL"
            filterName={OldGlobals.BRIEF_FILTER_OPTIONS_NAME.CHANNEL}
            title=""
            value={formData.CHANNEL}
            isDatePicker={false}
            onSelect={handleSelect}
            className="dropdown-width-300"
          />
          {(inValidateMandatoryField.isChannelInValid)&&<div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="error" /><label className='invalidCredential'>{Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.CHANNEL}</label></div>}
          </span>
          {}
        </div>
        <div className="brief-form-group">
          {isRequired(Globals.CREATE_NEW_BRIEF.LANGUAGE)}
          <span tabIndex={2} onBlur={validateLanguage}>
           <BriefDropdownList
            name="LANGUAGE"
            multiSelection={false}
            filterName={OldGlobals.BRIEF_FILTER_OPTIONS_NAME.LANGUAGE}
            value={formData.LANGUAGE}
            title=""
            isDatePicker={false}
            onSelect={handleSelect}
            className="dropdown-width-300"
            parentSelection={formData.CHANNEL}
          />
          {(inValidateMandatoryField.isLanguageInValid)&&<div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="error" /><label className='invalidCredential'>{Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.LANGUAGE}</label></div>}
          </span>
        </div>
        <div className="brief-form-group">
          {isRequired(Globals.CREATE_NEW_BRIEF.GENRE)}
          <span tabIndex={3} onBlur={validateGenre}>
          <BriefDropdownList
            name="GENRE"
            filterName={OldGlobals.CREATE_NEW_BRIEF.FILTER_OPTIONS_NAME.GENRE}
            title=""
            value={formData.GENRE}
            multiSelection={false}
            isDatePicker={false}
            onSelect={handleSelect}
            className="dropdown-width-300"
          />
          {(inValidateMandatoryField.isGenreInValid)&&<div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="error" /><label className='invalidCredential'>{Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.GENRE}</label></div>}
          </span>
        </div>
      </div>

      <div className="brief-form-row">
        <div className="brief-form-group">
          {isRequired(Globals.CREATE_NEW_BRIEF.FORMAT)}
          <span tabIndex={4} onBlur={validateFormat}>
          <BriefDropdownList
            name="FORMAT"
            multiSelection={false}
            filterName={OldGlobals.BRIEF_FILTER_OPTIONS_NAME.FORMAT}
            title=''
            value={formData.FORMAT}
            isDatePicker={false}
            onSelect={handleSelect}
            className="dropdown-width-300"
          />
          {(inValidateMandatoryField.isFormatInValid)&&<div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="error" /><label className='invalidCredential'>{Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.FORMAT}</label></div>}
          </span>
        </div>
        <div className="brief-form-group">
          {isRequired(Globals.CREATE_NEW_BRIEF.PRODUCTION_TYPE)}
          <span tabIndex={5} onBlur={validateProductionType}>
          <BriefDropdownList
            name="PRODUCTION_TYPE"
            multiSelection={false}
            filterName={OldGlobals.BRIEF_FILTER_OPTIONS_NAME.TYPE}
            value={formData.PRODUCTION_TYPE}
            title=''
            isDatePicker={false}
            onSelect={handleSelect}
            className="dropdown-width-300"
          />
          {(inValidateMandatoryField.isProductionTypeInValid)&&<div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="error" /><label className='invalidCredential'>{Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.PRODUCTION_TYPE}</label></div>}
          </span>
        </div>
        <div className="brief-form-group"></div>
      </div>
      <div className="brief-form-row">
        <div className="brief-form-group">
          {isRequired(Globals.CREATE_NEW_BRIEF.DESCRIPTION)}
           <span tabIndex={6} onBlur={validateDescription}>
          <TextArea
            placeHolder=''
            value={formData.DESCRIPTION}
            textAreaInput={(value) =>
              handleTextAreaChange("DESCRIPTION", value)
            }
            error={inValidateMandatoryField.isDescriptionInValid?Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.DESCRIPTION:""}
            className={`dropdown-width-300 brief-text-area ${
              formData.DESCRIPTION ? "brief-text-area-selected" : ""
            }`}
            maxCharacters={5000}
          />
          </span>
        </div>
        <div className={"brief-form-group"}>
          {isRequired(Globals.CREATE_NEW_BRIEF.SUBMISSION_REQUIREMENT)}
          <span tabIndex={7} onBlur={validateSubmissionRequirement}>
          <TextArea
            placeHolder=''
            value={formData.SUBMISSION_REQUIREMENT}
            textAreaInput={(value) =>
              handleTextAreaChange("SUBMISSION_REQUIREMENT", value)
            }
            error={inValidateMandatoryField.isSubmissionRequirementInValid?Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.SUBMISSION_REQUIREMENT:""}
            className={`dropdown-width-300 brief-text-area ${
              formData.SUBMISSION_REQUIREMENT ? "brief-text-area-selected" : ""
            }`}
          />
          </span>
        </div>
        <div className="brief-form-group"></div>
      </div>
      <div className="brief-form-row">
        <div className={"brief-form-group"}>
          <span tabIndex={8} onBlur={validateClosingDate}>
          <BriefDateDropdown
            inputLabel={Globals.CREATE_NEW_BRIEF.CLOSING_DATE}
            name="CLOSING_DATE"
            minDate={new Date()}
            onDateChange={onDateChange}
            selectedDate={formData.CLOSING_DATE}
            placeholderText=" "
          />
          {(inValidateMandatoryField.isClosingDateInValid && (formData.CLOSING_DATE===null || formData.CLOSING_DATE===""))&&<div><img id="login-error" className="login-error" src={Globals.IMG.ERROR} alt="error" /><label className='invalidCredential'>{Globals.CREATE_NEW_BRIEF_ERROR_MESSAGES.CLOSING_DATE}</label></div>}
          </span>
        </div>
        <div className="brief-form-group"></div>
        <div className="brief-form-group"></div>
      </div>
    </div>
  );
};
